import {UserReportReasonEnum} from '@colonist/game-base-types'
import {ViewPopup} from './ViewPopup.ts'
import {createSelectIn, createOptionIn} from '../ui_utils/DomUtils.ts'
import {type TranslationObject} from '@colonist/i18n'
import {ArrayUtils} from '@colonist/utils'

interface UserReportMapping {
    id: UserReportReasonEnum
    dropdownText: TranslationObject
}

const userReportMapping: UserReportMapping[] = [
    {id: UserReportReasonEnum.CheatingWithAnotherPlayer, dropdownText: {key: 'strings:popups.reportPopup.reasons.cheatingWithAnotherPlayer'}},
    {id: UserReportReasonEnum.AbusingChat, dropdownText: {key: 'strings:popups.reportPopup.reasons.abusingChat'}},
    {id: UserReportReasonEnum.InappropriateUsername, dropdownText: {key: 'strings:popups.reportPopup.reasons.inappropriateUsername'}},
    {id: UserReportReasonEnum.WastingTime, dropdownText: {key: 'strings:popups.reportPopup.reasons.wastingTime'}},
    {id: UserReportReasonEnum.Griefing, dropdownText: {key: 'strings:popups.reportPopup.reasons.griefing'}},
    {id: UserReportReasonEnum.ThrowingTheGame, dropdownText: {key: 'strings:popups.reportPopup.reasons.throwingTheGame'}},
]

const defaultReportedPopupText: TranslationObject = {key: 'strings:popups.reportPopup.reportedPopupText'}
export class UIPopupReportPlayer {
    static createReportPopup(playerName: string, reportActionCallBack: (playerName: string, reportReason: UserReportReasonEnum) => void, reportedPopupText: TranslationObject = defaultReportedPopupText) {
        const body: TranslationObject = {key: 'strings:popups.reportPopup.body', options: {playerUsername: playerName}}
        const emptySelectValue = ''
        let reportReason: UserReportReasonEnum | ''

        const reportPopup = new ViewPopup({key: 'strings:popups.reportPopup.title', options: {playerUsername: playerName}}, body, () => {
            if(reportReason == emptySelectValue) return
            reportActionCallBack(playerName, reportReason)
            const popup = new ViewPopup({key: 'strings:popups.reportPopup.reported'}, reportedPopupText, () => undefined, () => undefined, true)
            popup.removeXButton()
            popup.show()
        }, () => undefined, true)

        reportPopup.disableCheckButton()
        const select = createSelectIn(reportPopup.body,
            '',
            '',
            (value: string) => {
                if(value == emptySelectValue) {
                    reportPopup.disableCheckButton()
                    return
                }
                for(const reason of userReportMapping) {
                    if(String(reason.id) != value) continue
                    reportReason = reason.id
                    reportPopup.enableCheckButton()
                    return
                }
            })
        reportPopup.body.classList.add('popup-body-report')

        createOptionIn(select, emptySelectValue, {key: 'strings:popups.reportPopup.reasons.selection'})

        const randomizedReportOrderToPreventOrderingBias = ArrayUtils.shuffle(userReportMapping)

        for(const reason of randomizedReportOrderToPreventOrderingBias) {
            createOptionIn(select, String(reason.id), reason.dropdownText)
        }
        reportPopup.show()
    }
}
